<script setup lang="ts">
import {
  instanceOfBeamConstancyWorkResultDto,
  MeasurementStatus,
  MeasurementStatusDto,
  ResultDto,
} from '@/api/generator';
import { Measurement } from './types';
import ParameterTable from '../ParameterTable/ParameterTable.vue';
import AnalysisResults from './AnalysisResults.vue';
import MeasurementStatusComponent from './MeasurementStatus.vue';
import EvaluationStateComponent from '../evaluation/EvaluationState.vue';
import { computed } from 'vue';

const props = defineProps<{
  measurement?: Measurement;
  status?: MeasurementStatusDto;
  result?: ResultDto;
}>();

const displayedStatus = computed<MeasurementStatus | undefined>(() =>
  props.result ? 'Finished' : (props.status?.measurementStatus ?? undefined),
);
</script>

<template>
  <v-row>
    <v-col>
      <MeasurementStatusComponent
        :status="displayedStatus"
        :outcome="result?.output || undefined"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <ParameterTable
        :title="$t('TargetSystemParameter_other')"
        :parameters="measurement?.setup?.targetSystem"
      />
    </v-col>

    <v-col>
      <ParameterTable
        :title="$t('SupportSystemParameter_other')"
        :parameters="measurement?.setup?.supportSystem"
      />
    </v-col>
  </v-row>

  <v-divider class="mt-4 mb-5" />

  <v-row>
    <v-col>
      <div v-if="result && instanceOfBeamConstancyWorkResultDto(result)">
        <div class="mb-2 d-flex align-center">
          <div class="text-h5">
            {{ $t('Evaluation_one') }}
          </div>

          <div>
            <EvaluationStateComponent class="ml-2" :value="result.output ?? undefined" />
          </div>
        </div>

        <AnalysisResults
          :value="result.evaluationResults || undefined"
          :evaluations="measurement?.evaluations"
          :options="{
            enableComments: false,
            enableTrends: false,
          }"
        />
      </div>
    </v-col>
  </v-row>
</template>
